(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmEmailController', CrmEmailController);

    CrmEmailController.$inject = ['CrmEmail', 'AlertService', 'entity', '$uibModal', 'CoreService', '$sce'];

    function CrmEmailController (CrmEmail, AlertService, entity, $uibModal, CoreService, $sce) {
        var vm = this;

        vm.opportunity = entity;
        vm.page = 1;
        vm.itemsPerPage = 5;
        vm.crmEmails = [];
        vm.pinCrmEmails = [];
        vm.groupedCrmEmails = [];
        vm.employee = CoreService.getCurrentEmployee();

        vm.add = add;
        vm.edit = edit;
        vm.del = del;
        vm.isOwner = isOwner;
        vm.pin = pin;
        vm.getUnpin = getUnpin;
        vm.trustAsHtml = trustAsHtml;

        loadAll();

        function loadAll () {
            CrmEmail.findAllByFilter({
                opportunityId: vm.opportunity.id,
                corporationId: vm.opportunity.corporation.id,
                pin: true,
                unpaged: true
            }, function (data, headers) {
                vm.pinCrmEmails = data;
            }, onError);

            getUnpin();
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/crm-email/crm-email-dialog.html',
                controller: 'CrmEmailDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            date: new Date(),
                            description: null,
                            pin: false,
                            id: null,
                            opportunity: vm.opportunity,
                            employee: CoreService.getCurrentEmployee(),
                            corporation: CoreService.getCorporation()
                        }
                    }]
                }
            }).result.then(function () {
                vm.page = 1;
                loadAll();
            }, function () {
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/crm-email/crm-email-dialog.html',
                controller: 'CrmEmailDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CrmEmail', function (CrmEmail) {
                        return CrmEmail.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                loadAll();
            }, function () {
            });
        }

        function del(id) {
            CrmEmail.delete({id: id}, function () {
                loadAll();
            });
        }

        function isOwner(email) {
            return vm.employee.id == email.employee.id;
        }

        function pin(email) {
            CrmEmail.pin(email, function () {
                loadAll();
            })
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function getUnpin() {
            CrmEmail.findAllByFilter({
                opportunityId: vm.opportunity.id,
                corporationId: vm.opportunity.corporation.id,
                pin: false,
                page: vm.page - 1,
                size: vm.itemsPerPage
            }, function (data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.crmEmails = data;
            }, onError);
        }

        function trustAsHtml(email) {
            return $sce.trustAsHtml(email);
        }
    }
})();
